import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { config } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import { type PeopleQuickInfoProps as Props } from './types';

export const PeopleQuickInfo = memo(({ className, item }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('PeopleQuickInfo', className)}
      sx={SX.root}
      items={config}
      data={item}
    />
  );
});

PeopleQuickInfo.displayName = 'PeopleQuickInfo';
